import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/contrconfiguracao/';

class ContrConfiguracaoService {
    constructor() {
        this.idCliente = null;
        this.idContribuinte = null;
        this.idUsuario = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    save(contrConfiguracao, idUsuarioContr) {
        return axios.post(API_URL+'save?idUsuarioContr='+idUsuarioContr, JSON.stringify(contrConfiguracao),
            { headers: this.headers });
    }

    atualizarDadosContribuinte(contribuinte){
        return axios.post(API_URL+'atualizarDadosContribuinte', JSON.stringify(contribuinte),
            { headers: this.headers });
    }

    //get(idContribuinte) {
    //    return axios.get(API_URL + idContribuinte, { headers: this.headers });
    //}

    get(idContribuinte, idUsuario) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'get?idContribuinte='+idContribuinte+'&idUsuario='+idUsuario+'&idCliente='+this.idCliente, { headers: this.headers });
    }

    getContribuinteCadastro(idContribuinte) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'getContribuinteCadastro?idContribuinte='+idContribuinte+'&idCliente='+this.idCliente, { headers: this.headers });
    }

    removerLogo(idContribuinte) {
        return axios.post(API_URL+'removerLogomarca?idContribuinte='+idContribuinte, null, { headers: this.headers });
    }

    upload(idCliente, idUsuario, idContribuinte, file) {
        const formData = new FormData()
        formData.append('file', file, file.name)
        return axios.post(API_URL+'upload?idCliente='+idCliente+'&idUsuario='+idUsuario+'&idContribuinte='+idContribuinte, formData, { headers: this.headers });
    }

}

export default new ContrConfiguracaoService();